import React from 'react';

import {
  Flower, Cartridge, Extract, Edible, Merch, Misc, Preroll, Topical, Plant, More, All, Pill,
  Beverage,
  Cbd,
  Tincture,
  Metrc,
  NonInventory,
} from '../icons/types';
import { getPriority } from './productHelper';

const TYPES = {
  FLOWER: Flower,
  CARTRIDGE: Cartridge,
  EXTRACT: Extract,
  EDIBLE: Edible,
  MISC: Misc,
  MERCH: Merch,
  PREROLL: Preroll,
  TOPICAL: Topical,
  PLANT: Plant,
  MORE: More,
  ALL: All,
  PILL: Pill,
  BEVERAGE: Beverage,
  CBD: Cbd,
  TINCTURE: Tincture,
  METRC: Metrc,
  'NON-INV': NonInventory,
};

export const getSpecificIcon = (name, color, style) => {
  if (!name) {
    return null;
  }
  let props = { color };
  if (style) {
    props = { ...props, ...style };
  }
  const SpecificIcon = TYPES[name];
  return <SpecificIcon {...props} />;
};

export const getCategoriesWithSubTypesByConfig = (subCat) => {
  let categories = [];

  for(let key in subCat) {
    categories.push({
      type: key,
      subtypes: subCat[key],
      priority: getPriority(key),

    });
  }
  
  categories.sort((a, b) => a.priority - b.priority);

  return categories;
}


// WEBPACK FOOTER //
// ./src/helpers/producttypes.js